import { ui } from "@/components/ui";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

interface DiarySummaryAccordionProps {
  value?: string;
  isComplete: boolean;
  title: string;
  preview?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function DiarySummaryAccordion({
  value,
  isComplete,
  title,
  preview,
  children,
  className,
}: DiarySummaryAccordionProps) {
  return (
    <ui.AccordionItem
      value={value ?? title}
      className={cn(
        "bg-slate-50 dark:bg-slate-900 border border-slate-300  rounded-lg",
        !isComplete && "border-amber-500 dark:border-amber-500",
        className,
      )}
    >
      <ui.AccordionTrigger className="px-4">
        <div className="flex justify-between items-center w-full">
          <span className="font-medium text-base">{title}</span>
          {preview && <div className="flex items-center gap-2">{preview}</div>}
        </div>
      </ui.AccordionTrigger>
      <ui.AccordionContent className="px-4 pb-4">
        {children}
      </ui.AccordionContent>
    </ui.AccordionItem>
  );
}
